import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';

/** The journal's retention line ("Les actions sont conservées N mois") — no months, no line. */
const RetentionNotice = ({ months }: { months: number | null }) => {
  const { t } = useTranslation();
  if (months == null) return null;
  return (
    <span className="inline-flex items-center gap-1.5">
      <Clock className="h-3.5 w-3.5" aria-hidden="true" />
      {t('Actions are kept for {{count}} month', { count: months })}
    </span>
  );
};

export default RetentionNotice;
